// extracted by mini-css-extract-plugin
module.exports = {"notification":"CustomForm_notification__7UxTM","notification__content":"CustomForm_notification__content__w9xWS","notification__wrapper":"CustomForm_notification__wrapper__tZNkT"};